module.exports = __webpack_public_path__ + "img/link__call-me——zh.58f2e090.png";